module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/saloon.261c8af9.svg";